//local URL
    // const API_BASE_URL = "http://192.168.9.56:3000/api";

 //uat URL
    //   const API_BASE_URL = "https://winedge.term.value.taction.in/api/api";
//prod Url
const API_BASE_URL = "https://winedge.taction.in/api";
export default API_BASE_URL;